import { Controller } from "@hotwired/stimulus"

// Dispatches a document-level "ai-chip:clicked" CustomEvent when any chip
// inside this controller's element is clicked. The composer-autosize
// controller listens on document and fills the textarea with the chip's
// data-prompt. Pub/sub keeps the chip and composer partials decoupled —
// they don't share a common Stimulus parent.
export default class extends Controller {
  fill(event) {
    const prompt = event.currentTarget.dataset.prompt
    if (!prompt) return
    document.dispatchEvent(new CustomEvent("ai-chip:clicked", { detail: { prompt } }))
  }
}
